export function HeaderMediumIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M5 4a1 1 0 011 1v6h4V5a1 1 0 112 0v14a1 1 0 11-2 0v-6H6v6a1 1 0 11-2 0V5a1 1 0 011-1zm16.371 8.071a.997.997 0 00-1.18.34L18 15.334l-2.193-2.924a.984.984 0 00-.36-.304.995.995 0 00-.763-.054.999.999 0 00-.684.96V19a1 1 0 102 0v-3l1.186 1.581a1.004 1.004 0 001.239.325.993.993 0 00.389-.325L20 16v3a1 1 0 102 0v-5.985a.997.997 0 00-.376-.797 1.001 1.001 0 00-.253-.147z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
